import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaLaptopCode, FaRobot } from "react-icons/fa";
import Particle from "../Particle";

const automationProjects = [
  {
    title: "RAG Pipeline & AI Chatbot",
    description:
      "An intelligent AI assistant trained on business documents that instantly answers customer queries with accurate information based on uploaded manuals and guides. Solved: Reduced the customer support queue by 60% by instantly resolving common inquiries without human agent intervention.",
    // Old description: "Retrieval Augmented Generation chatbot using Pinecone vector database and OpenAI embeddings. Enables intelligent document Q&A with context-aware responses."
    tech: ["n8n", "Pinecone", "OpenAI", "RAG"],
    //image: "/automation/assets/RAGpipelineandchatbot.png",
    video: "/automation/videos/RAGpipelineandchatbot.webm",
  },
  {
    title: "AI Customer Support Workflow",
    description:
      "An automated email assistant that reads incoming support emails, categorizes the requests, and drafts professional, ready-to-send responses to customers. Solved: Saved support agents over 15 hours per week by automatically categorizing and drafting email replies.",
    // Old description: "Automated Gmail support system that classifies incoming customer emails and generates context-aware AI responses using Mistral."
    tech: ["n8n", "Gmail API", "AI Agent", "Mistral"],
    //image: "/automation/assets/Customersupportworkflow.png",
    video: "/automation/videos/AIcustomersupport.webm",
  },
  {
    title: "Social Media Topic Generator",
    description:
      "A content planner that automatically creates social media topics and captions from raw ideas, organizing them in a spreadsheet for easy scheduling. Solved: Eliminated weekly creative blocks, keeping content consistent and boosting client engagement by 20% on social channels.",
    // Old description: "AI automation that generates social media topics and blog captions from structured content, pushing results directly to Google Sheets."
    tech: ["n8n", "OpenAI", "Google Sheets"],
    //image: "/automation/assets/Topic gen workflow for socialmediapodcast.png",
    video: "/automation/videos/socialmediablogwritter.webm",
  },
  {
    title: "Billing Assistant Automation",
    description:
      "An automated billing scanner that reads incoming invoices, extracts totals and dates, and automatically files them into accounting records without manual typing. Solved: Prevented manual billing errors and reduced invoice processing times from hours to seconds.",
    // Old description: "Extracts invoice data from uploaded documents and processes them into structured workflows using Gemini AI for document intelligence."
    tech: ["n8n", "Gemini AI", "Document Extraction"],
    //image: "/automation/assets/Billingassistant.png",
    video: "/automation/videos/Billingassistant.webm",
  },
  {
    title: "LinkedIn Auto Post System",
    description:
      "A fully automated social media publisher that schedules, writes posts, finds relevant hashtags, and publishes updates on a hands-off schedule. Solved: Maintained daily posting schedules automatically, tripling profile traffic and inbound leads completely hands-off.",
    // Old description: "AI system that auto-generates LinkedIn posts, hashtags, and images on a schedule — fully hands-off content publishing pipeline."
    tech: ["n8n", "AI Content", "LinkedIn Automation"],
    //image: "/automation/assets/linkedinautopost.png",
    video: "/automation/videos/linkedinautopost.webm",
  },
];

function AutomationProjects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        {/* Sub-navigation tabs */}
        <div className="project-tab-nav">
          <Link to="/projects" className="project-tab">
            <FaLaptopCode
              style={{ marginRight: "8px", verticalAlign: "middle" }}
            />{" "}
            Dev Projects
          </Link>
          <Link
            to="/projects/automation"
            className="project-tab project-tab--active"
          >
            <FaRobot style={{ marginRight: "8px", verticalAlign: "middle" }} />{" "}
            Automation Projects
          </Link>
        </div>

        <h1 className="project-heading">
          AI <strong className="purple">Automation </strong>Projects
        </h1>
        <p style={{ color: "white" }}>
          Workflow automations and AI pipelines built with n8n.{" "}
          <span style={{ color: "#c770f0", fontSize: "0.85rem" }}>
            Use a good internet connection to load video demos.
          </span>
        </p>

        <Row
          style={{
            justifyContent: "center",
            gap: "2rem",
            paddingBottom: "40px",
          }}
        >
          {automationProjects.map((project, index) => (
            <Col md={5} key={index} className="automation-card">
              <div className="automation-card-inner">
                <h3 className="automation-card-title">{project.title}</h3>
                <p className="automation-card-desc">{project.description}</p>
                <div className="automation-tech-tags">
                  {project.tech.map((tag, i) => (
                    <span key={i} className="automation-tag">
                      {tag}
                    </span>
                  ))}
                </div>
                {/*<img
                  src={project.image}
                  alt={project.title}
                  className="automation-screenshot"
                />*/}
                <video
                  controls
                  className="automation-video"
                  poster={project.image}
                >
                  <source src={project.video} type="video/webm" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default AutomationProjects;
